import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from '@trello/graphql';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary, ChunkLoadErrorBoundary } from '@trello/error-reporting';
import type { AboutThisBoardModalProps } from './AboutThisBoardModal';

export const LazyAboutThisBoardModal: FunctionComponent<AboutThisBoardModalProps> = (
  props,
) => {
  const AboutThisBoardModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "about-this-board-modal" */ './AboutThisBoardModal'
      ),
    { preload: false, namedImport: 'AboutThisBoardModal' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'About This Board Modal',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <ApolloProvider client={client}>
            <AboutThisBoardModal {...props} />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
